// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"Layout_pageWrapper__ih8qm","pageContent":"Layout_pageContent__C01AH"};